module.exports = __webpack_public_path__ + "img/somos.29cb7480.png";